<template>
<div ref="modal" class="modal fade" :id="id" tabindex="-1" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <Loader v-if="isLoading"></Loader>
            <div class="modal-header">
                <h5 class="modal-title">Copy Quiz</h5>
                <button type="button" class="close" @click="closeModal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group mb-0">
                    <square-icon
                        size="1.5x"
                        :class="isAutoTranslateEnabled ? 'cursor-pointer' : 'cursor-not-allowed text-gray'"
                        v-if="!isAutoTranslate"
                        @click="toggleAutoTranslate" />
                    <check-square-icon
                        size="1.5x"
                        :class="['text-success', isAutoTranslateEnabled ? 'cursor-pointer' : 'cursor-not-allowed']"
                        v-if="isAutoTranslate"
                        @click="toggleAutoTranslate" />
                    <label :class="{'mb-0 mt-1 ml-2': true, 'text-gray cursor-not-allowed': !isAutoTranslateEnabled}" @click="toggleAutoTranslate">Auto-Translate</label>
                </div>
                <select class="custom-select mt-3" id="inputGroupSelect01" v-if="isAutoTranslate" v-model="selectLang">
                    <option v-for="item in lang" :key="item.code" :value="item.code">
                        {{ item.name }} ({{ item.code }})
                    </option>
                </select>
            </div>
            <div class="modal-footer">
                <button class="btn btn-warning" @click="duplicateQuiz()">
                    Copy
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import jQuery from 'jquery'
import {
    CheckSquareIcon,
    SquareIcon
} from "vue-feather-icons";
import Loader from '@/components/Loader'
import datalist from '../../../../frontend/src/mixins/datalist'

export default {
    mixins: [ datalist ],

    components: {
        CheckSquareIcon,
        SquareIcon,
        Loader
    },

    props: {
        id: {
            type: String,
            default: "",
        },
    },

    data() {
        return {
            isAutoTranslate: false,
            selectLang: null,
            quizId: null,
            isLoading: false
        }
    },

    computed: {
        lang() {
            return this.languageList;
        },

        isAutoTranslateEnabled() {
            return process.env.VUE_APP_ENABLE_AUTO_TRANSLATE === 'true'
        }
    },

    mounted() {
        jQuery(this.$el).off('show.bs.modal')
        jQuery(this.$el).on('show.bs.modal', () => {
            this.isLoading = false
            this.selectLang = this.lang[0].code
            this.isAutoTranslate = false
        })
    },

    methods: {
        closeModal() {
            jQuery(`#duplicate-quiz-modal`).modal("hide");
        },

        async duplicateQuiz () { // data.quizId, data.translate
            this.isLoading = true

            const payload = {
                quizId: this.quizId,
                translate: this.isAutoTranslate ? this.selectLang.toLowerCase() : '',
                duplicate: true
            }

            this.$emit('duplicate', payload)
        },

        setId(id) {
            this.quizId = id
        },

        toggleAutoTranslate() {

            if (!this.isAutoTranslateEnabled) {
                return window.shout.error('Auto translation is disabled')
            }

            this.isAutoTranslate = !this.isAutoTranslate
        }
    },
};
</script>

<style lang="scss">
#duplicate-quiz-modal {
    .form-group {
        column-gap: 8px;
    }
}
</style>
